{
  "header": {
    "nameShowStaticText": true,
    "nameStaticText": "Used Model: OPC 40082-2",
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "d138c8a1-bfed-422a-a041-9b93f12b09f3",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
      "nodeId": "ns=1;i=6220",
      "displayName": "Model",
      "variablePath": "Identification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "pr_opc40082-2.jpg"
    }
  },
  "timeline": {
    "variable": {
      "id": "25f7cad8-f8cf-4b4a-bf04-ffc57baf78a3",
      "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
      "nodeId": "ns=1;i=6251",
      "displayName": "EnablePower",
      "variablePath": "Operation.EnablePower",
      "dataType": "Boolean",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "colorValues": {
      "False": "#ffff00",
      "True": "#00ff00"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Machine Type",
              "showAsLink": false,
              "valueVariable": {
                "id": "54ebbbb2-d6b1-4a49-a5b3-1d17769e3922",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
                "nodeId": "ns=1;i=6218",
                "displayName": "DeviceClass",
                "variablePath": "Identification.DeviceClass",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "ee7a967c-7096-477e-a0f1-44a863e83373",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
                "nodeId": "ns=1;i=6219",
                "displayName": "Manufacturer",
                "variablePath": "Identification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Model",
              "showAsLink": false,
              "valueVariable": {
                "id": "d138c8a1-bfed-422a-a041-9b93f12b09f3",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
                "nodeId": "ns=1;i=6220",
                "displayName": "Model",
                "variablePath": "Identification.Model",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "792eaea8-69db-4203-b02f-ecaeb996de6c",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
                "nodeId": "ns=1;i=6221",
                "displayName": "SerialNumber",
                "variablePath": "Identification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Monitoring",
      "rows": [
        {
          "isPlaceholder": true,
          "elements": [
            {
              "type": 1,
              "isPlaceholder": false,
              "label": "Temperature",
              "valueVariable": {
                "id": "eea77a48-6eb3-4222-8005-d93929b8d72e",
                "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
                "nodeId": "ns=1;i=6123",
                "displayName": "ActualValue",
                "variablePath": "Temperature.ActualValue",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            }
          ],
          "placeholderObject": "Zones.Zone_<Nr>.[PLACEHOLDER]",
          "placeholderConditionType": {
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
            "nodeId": "ns=1;i=1006",
            "displayName": "ZoneType",
            "typeDefinition": "nsu=http://opcfoundation.org/UA/PlasticsRubber/HotRunner/;i=1006",
            "subTypes": []
          },
          "titleVariable": {
            "id": "a89a4c77-adb9-4bf0-ad44-3c146a86595a",
            "modelUri": "http://opcfoundation.org/UA/PlasticsRubber/HotRunner/",
            "nodeId": "ns=1;i=6388",
            "displayName": "Name",
            "variablePath": "Name",
            "dataType": "String",
            "valueRank": -1,
            "modellingRule": "Optional",
            "hasProperties": false
          }
        }
      ]
    }
  ]
}
